export default __webpack_public_path__ + "495a4ed00fd5569a0f346343c6ba13d0.svg";